import { createRoute } from "@tanstack/solid-router";
import { appRoute, useAppLayoutContext } from "./route";
// Dashboard is the landing route — needed on virtually every cold entry, so it
// ships in the main bundle (NOT lazy) and renders directly with the shell.
// No <Suspense> skeleton wraps it: it's local-first (SQLite reads resolve in
// ~50ms) and hydrates synchronously from the TanStack cache, so a skeleton
// would only flash + cause a remount. All its queries are non-suspending.
import { Dashboard } from "@/features/dashboard/components/dashboard";

function DashboardPage() {
  const { openChoiceDialog } = useAppLayoutContext();

  return (
    <Dashboard
      onAddList={(groupId) => {
        openChoiceDialog(groupId);
      }}
    />
  );
}

export const indexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/",
  component: DashboardPage,
});
